import React, { Component, Fragment, useEffect, useState } from 'react'
// import HomeGrid from './Grid'
import HomeGrid from './HomeGrid'
import {
  makeStyles,
  withStyles,
  CircularProgress,
  SvgIcon,
  Fade,
  Card,
  Typography,
} from '@material-ui/core'
import PageHeader from '../PageHeader'
import SyncIcon from '@material-ui/icons/Sync'
import TelegramIcon from '@material-ui/icons/Telegram'
import GpsFixedIcon from '@material-ui/icons/GpsFixed'
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import HowToRegIcon from '@material-ui/icons/HowToReg'
import PublicIcon from '@material-ui/icons/Public'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import BoomModule from '../boomerang/BoomModule'
import EventMarketingModule from '../eventMarketing/EventMarketingModule'
import TentpoleMod from '../tentpole/TentpoleMod'
import RfmModule from '../rfm/RfmModule'
import ZipModule from '../zipcode/ZipModule'
import OtbMod from '../otb/OtbModule'
import LostOppMod from '../lostOpp/LostOppsModule'
import CustomerRetentionModule from '../customerRetention/CustRetModule'
import DemoModule from '../demographics/DemoModule'
import Calendar from '../calendar/Calendar'
import RoiHome from '../roi/RoiHome'
import EventHome from '../tentpole/EventHome'
import Cookies from 'js-cookie'
import { BiCalendarEvent, BiDirections } from 'react-icons/bi'
import { RiHome4Fill } from 'react-icons/ri'

import '../../assets/grid.css'

function BoomIcon(props) {
  return(
    <SvgIcon {...props}>
      <path d="M10 2H4C2.9 2 2 2.9 2 4S2.9 6 4 6H8L10 2M18 2C20.2 2 22 3.8 22 6V12L18 14C18 9.6 14.4 6 10 6L12 2H18M18 20V16L22 14V20C22 21.1 21.1 22 20 22S18 21.1 18 20Z" />
    </SvgIcon>
  )
}

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"
// const base_url = 'https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    // margin: '1em',
    padding: "2em",  
  },
  circularprogress: {
    marginLeft: '45vw',
    marginTop: '40vh'
  }
}))


const getHomeList = (user, dark) =>  {
  console.log(user)
  const homeList = [
  {
    id: 1,
    icon: <BiCalendarEvent style={{fontSize: '25px'}}/>,
    title: 'Calendar',
    path: '/calendar',
    panel: <Calendar darkMode={dark} tooltip={true}/>,
    color: '#fc5664',
    colorDark: '#ba2734',
    // colorDark: 'rgba(189, 76, 70, 0.5)',
    tooltip: 'Green arrows pointing upward indicate a positive change in sales from the previous year. Red Arrows point downward indicate a negative change in sales from the previous year.'
  },
  {
    id: 2,
    icon: <BoomIcon />,
    title: 'Boomerang ROI',
    path: '/boomerang',
    panel: <BoomModule darkMode={dark} />,
    color: '#25aae1',
    // colorDark: 'rgba(59, 128, 184, 0.5)',
    colorDark: '#166a8c',
    subheader: 'Past 12 Months'
  },
  {
    id: 3,
    icon: <BiDirections style={{fontSize: '25px'}}/>,
    title: 'Boomerang Lost Opportunity',
    path: '/boomerang/lost-opportunity',
    panel: <LostOppMod darkMode={dark} />,
    color: '#25aae1',
    colorDark: '#166a8c',
    subheader: 'Current Calendar Year'
  },
  // {
  //   id: 4,
  //   icon: <MarkunreadMailboxIcon style={{fontSize: '22px'}}/>,
  //   title: 'Event Marketing',
  //   path: '/event-marketing',
  //   // panel: <EventMarketingModule darkMode={true} />,
  //   panel: <TentpoleMod darkMode={true} />,
  //   color: '#25aae1',
  //   colorDark: '#166a8c',
  //   subheader: 'Past 12 Months'
  // },
  {
    id: 10,
    icon: <MarkunreadMailboxIcon style={{fontSize: '22px'}}/>,
    title: 'Event Marketing',
    path: '/event-marketing',
    panel: <EventMarketingModule darkMode={dark} />,
    // panel: <TentpoleMod darkMode={true} />,
    color: '#25aae1',
    colorDark: '#166a8c',
    subheader: 'Past 12 Months'
  },
  {
    id: 5,
    icon: <HowToRegIcon style={{fontSize: '24px'}}/>,
    title: 'RFM Counts',
    path: '/rfm-counts',
    panel: <RfmModule darkMode={dark} />,
    color: '#ffa300',
    colorDark: '#b3760b',
    // colorDark: 'rgba(235, 143, 5, 0.5)',
  },
  {
    id: 6,
    icon: <ShoppingCartIcon style={{fontSize: '22px'}}/>,
    title: 'OTB Counts',
    path: '/otb-counts',
    panel: <OtbMod darkMode={dark} />,
    color: '#ffa300',
    colorDark: '#b3760b',
  },
  {
    id: 7,
    icon: <SyncIcon style={{fontSize: '24px'}}/>,
    title: 'Customer Retention',
    path: '/customer-retention',
    panel: <CustomerRetentionModule darkMode={dark} />,
    color: '#ffa300',
    colorDark: '#b3760b',
  },
  {
    id: 8,
    icon: <LocationOnIcon />,
    title: 'Zip Codes',
    path: '/zip-code',
    panel: <ZipModule darkMode={dark} />,
    color: '#69bc45',
    colorDark: '#3f8222',
    // colorDark: 'rgba(23, 171, 3, 0.5)',
    subheader: 'Top Zip Codes By YOY Sales'
  },
  {
    id: 9,
    icon: <PublicIcon />,
    title: 'Demographics',
    path: '/demographics',
    panel: <DemoModule darkMode={dark} />,
    color: '#69bc45',
    colorDark: '#3f8222',
  },
]

return homeList
}
export default function Home(props) {
  const { dark } = props
  const token = Cookies.get('token')
  const classes = useStyles()
  const [user, setUser] = useState(null)
  const [homeGrid, setHomeGrid] = useState(null)

  const getUser = () => {
    const request = fetch(`${base_url}/user`, {
      headers: {
        'token': token
      }
    })

    request
    .then(response => response.json())
    .then(data => {
      setUser(data[0])
      setHomeGrid(getHomeList(data[0], dark))
    })
    .catch(error => console.log(error))
  }

  useEffect(() => {
    getUser()
  }, [])


  if(!user) return <div />

  return(
    <div className={classes.root}>      
      <PageHeader details={{icon: <RiHome4Fill />, title: 'HOME PAGE'}}/>      
      <br/>      
      <WelcomeBoard user={user.fname + ' ' + user.lname} companyName={user.company}/>      
      <div className="home-grid">
        <HomeGrid
          homeList={homeGrid}
          user={user.userID}
          layout={user.arr_layout}
          dbO={user.db_owner}
          darkTheme={dark}
        />
      </div>
    </div>
  )
}

const WelcomeBoard = ({user, companyName}) => (
  <Fade in={true} timeout={500}>
    <Card className="welcome-card">
      <Typography variant="h5" className="user">Hello {user} ({companyName})</Typography>
      <Typography variant="caption" className="message">Welcome to you SmartDash by LS Direct</Typography>
    </Card>
  </Fade>
)
